import { getAllArticles, getGlobalConfig, getHomeConfig, transformStaticProps } from '@/lib/api';
import Layout from '@/components/layout';
import { useEffect } from 'react';
import { pageEvent } from '@/lib/gtm';
import { appendSlashStart, transformArticles } from '@/lib/slug';
import ArticleCardSimple from '@/components/cards/articlesimple';

const ArticleList = ({ config }) => {
	useEffect(() => {
		pageEvent(config.slug);
	}, [config]);

	return (
		<Layout {...config} useSelfReferringCanonicalUrl={true}>
			<div className="container pb-5 px-xs pt-5">
				{config.articles.map((article) => {
					if (article.site === 'Urinkollenfi') return;
					return (
						<div key={article.id} className="row pb-5">
							<ArticleCardSimple
								key={article.id}
								title={article.title}
								text={article.leftContent[0].content}
								readMoreUrl={appendSlashStart(article.slug)}
							/>
						</div>
					);
				})}
			</div>
		</Layout>
	);
};

export const getStaticProps = async ({ preview, previewData }) => {
	const config = await getGlobalConfig(!!preview, previewData);

	const site =
		config.SiteConfiguration.Site === 'Kollarnase' ? null : config.SiteConfiguration.Site;

	const articles = transformArticles(await getAllArticles(site));

	return await transformStaticProps({
		configuration: { ...config },
		...(await getHomeConfig(!!preview, previewData)),
		articles: [...articles],
		preview: !!preview,
		previewData: previewData ?? null,
	});
};

export default ArticleList;
